import TaskOperationArticleStatusModel           from 'Models/intervention/TaskOperationArticleStatusModel';
import TaskOperationModel                        from 'Models/intervention/TaskOperationModel';
import SourceModel                               from 'Models/invoice/SourceModel';
import ContractIterationItemActivityArticleModel from 'Models/sales/ContractIterationItemActivityArticleModel';
import QuotationItemActivityArticleModel         from 'Models/sales/QuotationItemActivityArticleModel';
import doc                                       from 'decorators/doc';
import model                                     from 'decorators/model';
import nestedResolvable                          from 'decorators/nestedResolvable';
import { Timestampable }                         from 'helpers/traits';
import { Blamable }                              from 'helpers/traits';
import InterventionPrivateApiModel               from 'modelx/models/abstracts/InterventionPrivateApiModel';

@model.staticLabel('Déboursé')
@model.urnResource('task_operation_article')
@doc.path('/task_operation_articles/{?id}')
export default class TaskOperationArticleModel extends Blamable(Timestampable(InterventionPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'exists[taskOperationArticleOrders]': '0' | '1';
		'sourceUrn': Urn;
		'taskOperation': id;
		'taskOperation.scheduleEndDate[after]': string | Date;
		'taskOperation.scheduleEndDate[before]': string | Date;
		'taskOperation.scheduleEndDate[strictly_after]': string | Date;
		'taskOperation.scheduleEndDate[strictly_before]': string | Date;
		'taskOperation.scheduleStartDate[after]': string | Date;
		'taskOperation.scheduleStartDate[before]': string | Date;
		'taskOperation.scheduleStartDate[strictly_after]': string | Date;
		'taskOperation.scheduleStartDate[strictly_before]': string | Date;
		'taskOperation.task': id;
		'taskOperation.task.owner.ownerSubPartition': id;
		'taskOperation.task.owner.ownerSubPartition.partitionUrn': Urn;
		'taskOperation.task.owner.ownerSubPartition.subPartitionUrn': Urn;
		'taskOperation.task.taskHolder': id;
		'taskOperation.task.taskHolder.holderUrn': Urn;
		'taskOperationArticleOrders': id;
		'taskOperationArticleOrders.orderUrn': Urn;
		'taskOperationArticleOrders.taskOperationArticleOrderStatus': id;
		'taskOperationArticleOrders.taskOperationArticleOrderStatus.reference': InterventionTaskOperationArticleOrderStatusReference;
		'taskOperationArticleStatus': id;
		'taskOperationArticleStatus.reference': InterventionTaskOperationArticleStatusReference;
		'updatedAt[after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedAt[strictly_before]': string | Date;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
		'sourceUrn': string;
		'taskOperation.scheduleEndDate': string;
		'taskOperation.scheduleStartDate': string;
		'updatedAt': string;
	}> = {};

	@doc.string declare label: string;
	@doc.string declare quantity: string;
	@doc.modelUrn(SourceModel) declare source: SourceModel;
	@doc.model(TaskOperationModel) declare taskOperation: TaskOperationModel;
	@doc.model(TaskOperationArticleStatusModel) declare taskOperationArticleStatus: TaskOperationArticleStatusModel;

	// Pour la source, il s'agit du contractIterationItemActivityArticle ou quotationItemActivityArticle
	public get itemActivityArticle(): ContractIterationItemActivityArticleModel | QuotationItemActivityArticleModel | null {
		return this.source as never;
	}
	
	@nestedResolvable()
	public get company() {
		return this.taskOperation.task.taskHolder.owner.company;
	}

	public get holderUrn() {
		return this.taskHolder.holder.urn;
	}

	@nestedResolvable()
	public get task() {
		return this.taskOperation.task;
	}

	@nestedResolvable()
	public get taskHolder() {
		return this.taskOperation.task.taskHolder;
	}

	@nestedResolvable()
	public get taskZone() {
		return this.taskOperation.taskZone;
	}
}